// Shared UI metadata for statuses, roles and material categories.

export const STATUS_META = {
  healthy: { label: "On Track", dot: "bg-emerald-500", badge: "bg-emerald-100 text-emerald-800 border-emerald-200", bar: "bg-emerald-500" },
  attention: { label: "At Risk", dot: "bg-amber-500", badge: "bg-amber-100 text-amber-800 border-amber-200", bar: "bg-amber-500" },
  critical: { label: "Critical", dot: "bg-rose-500", badge: "bg-rose-100 text-rose-800 border-rose-200", bar: "bg-rose-500" },
  completed: { label: "Completed", dot: "bg-blue-500", badge: "bg-blue-100 text-blue-800 border-blue-200", bar: "bg-blue-500" },
  draft: { label: "Draft", dot: "bg-slate-400", badge: "bg-slate-100 text-slate-700 border-slate-200", bar: "bg-slate-400" },
};

export const APPROVAL_META = {
  pending: { label: "Pending", badge: "bg-amber-100 text-amber-800 border-amber-200" },
  booked: { label: "Booked", badge: "bg-blue-100 text-blue-800 border-blue-200" },
  approved: { label: "Approved", badge: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  received: { label: "In-housed", badge: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export const ROLE_LABELS = {
  developer: "Developer",
  owner: "Owner",
  manager: "Manager",
  senior_merchandiser: "Senior Merchandiser",
  merchandiser: "Merchandiser",
};

export const NOTIF_META = {
  critical: { color: "text-rose-600", dot: "bg-rose-500" },
  warning: { color: "text-amber-600", dot: "bg-amber-500" },
  success: { color: "text-emerald-600", dot: "bg-emerald-500" },
  info: { color: "text-blue-600", dot: "bg-blue-500" },
};

export const CATEGORIES = [
  { key: "fabrication", title: "Fabrication", addLabel: "Add fabric", singular: "fabric", unit: "mtr/pc", showFabricType: true },
  { key: "interlining", title: "Sewing Items — Interlining", addLabel: "Add interlining", singular: "interlining", unit: "yds/pc" },
  { key: "buttons", title: "Sewing Items — Buttons", addLabel: "Add button", singular: "button", unit: "pcs/pc", showSize: true },
  { key: "threads", title: "Sewing Items — Thread & Tape", addLabel: "Add thread / tape", singular: "thread / tape", unit: "mtr/pc" },
  { key: "labels", title: "Other Items — Labels", addLabel: "Add label", singular: "label", unit: "pcs/pc" },
  { key: "finishing", title: "Finishing Items", addLabel: "Add finishing item", singular: "finishing item", unit: "pcs/pc" },
  { key: "packaging", title: "Packaging", addLabel: "Add packaging item", singular: "packaging item", unit: "pcs/pc" },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

export function fmtNumber(n) {
  const num = Number(n || 0);
  return num.toLocaleString("en-US", { maximumFractionDigits: 2 });
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}
